module.exports = __webpack_public_path__ + "static/media/46-ack-bach.5404df4b.jpeg";